import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter, routerReducer, routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import { ZenderApi } from 'zender-api-client';
import qs from 'querystring';
import assign from 'lodash/assign';
import includes from 'lodash/includes';
import isUndefined from 'lodash/isUndefined';

import * as appReducers from './reducers';
import appSagas from './sagas';
import config from './config';
import App from './ui';
import Instructions from './ui/instructions';

import './styles/main.scss';

class Studio {
	constructor() {
		this.history = createHistory();
	}

	initWebStuff = () => Promise.resolve();

	initZenderApi() {
		return new Promise((resolve) => {
			const parsedQs = qs.parse(document.location.search.substring(1));
			const alias = document.location.pathname.split('/')[1];
			if (alias) {
				const options = {
					reducers: {
						...appReducers,
						router: routerReducer,
					},
					sagas: appSagas,
					middleware: routerMiddleware(this.history),
					persistenceStore: {
						name: 'zender-studio',
						whitelist: ['auth', 'ui'],
					},
					debug:
						parsedQs.debug !== 'false' &&
						(includes(['staging', 'development'], process.env.DEPLOY_ENV) ||
							parsedQs.debug !== undefined),
				};
				const zenderConfig = assign({}, config, {
					targetAlias: alias,
					private: !isUndefined(parsedQs.token),
					token: parsedQs.token,
				});
				this.zenderApi = new ZenderApi(zenderConfig, options);
				this.zenderApi.init((target) => {
					console.log('Target initialized', 'postInit', { target });
					resolve('app');
				});
			} else {
				resolve('instructions');
			}
		});
	}

	renderApp() {
		ReactDOM.render(
			<Provider store={this.zenderApi.getStore()}>
				<ConnectedRouter history={this.history}>
					<App />
				</ConnectedRouter>
			</Provider>,
			document.getElementById('root')
		);
	}

	renderInstructions = () => {
		ReactDOM.render(<Instructions locale={{}} />, document.getElementById('root'));
	};

	async boot() {
		await this.initWebStuff();
		const section = await this.initZenderApi();
		switch (section) {
			case 'app':
				this.renderApp();
				break;
			case 'instructions':
				this.renderInstructions();
				break;
			default:
				break;
		}
	}
}

const studio = new Studio();
studio.boot();



// WEBPACK FOOTER //
// ./src/index.js